import React from "react";
import NotesApp from "./NotesApp";
import Auth from "./Authentication.js"
import {useState, useEffect} from "react";
import { supabase } from "./supabase-client.js";

function App() {
  
  const [session, setSession] = useState(null);


  const fetchSession = async () => {
    const currentSession = await supabase.auth.getSession();
    setSession(currentSession.data.session);
  }

  useEffect(() =>{

    fetchSession();

    const {data : authListener} = supabase.auth.onAuthStateChange((_event, session) => {setSession(session);})

    return() => {
      authListener.subscription.unsubscribe();
    }

  }, [])

  return ( <div className="page">
    {session ? <NotesApp session={session}></NotesApp> : <Auth></Auth>}
    
    
  </div> );
}

export default App;
